module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Light.9a77ebfa.ttf";